import { Property } from '../../domain/entities/Property';

type PropertyDTO = {
  id: string;
  latitude: number;
  longitude: number;
  list_price: number | null;
  bedrooms: number | null;
  bathrooms: number | null;
  sqft: number | null;
  street_number: string | null;
  street_name: string | null;
  city: string | null;
  state: string | null;
  zipcode: string | null;
  image_url: string | null;
  cumulative_days_on_market: number | null;
  potential_equity: number | null;
  status: string | null;
  days_since_sold: number | null;
};

function buildAddress(dto: PropertyDTO): string | null {
  const street = [dto.street_number, dto.street_name].filter(Boolean).join(' ');
  const cityState = [dto.city, dto.state].filter(Boolean).join(', ');
  const parts = [street, cityState, dto.zipcode].filter(Boolean);
  return parts.length ? parts.join(', ') : null;
}

// translates vendor API DTO to domain object
export function propertyDtoToDomain(dto: PropertyDTO): Property | null {
  try {
    const listPrice = dto.list_price ?? null;
    const sqft = dto.sqft ?? null;
    const listPricePerSqft =
      listPrice !== null && sqft !== null && sqft > 0 ? listPrice / sqft : null;

    return new Property(
      dto.id,
      buildAddress(dto),
      dto.bedrooms ?? null,
      dto.bathrooms ?? null,
      sqft,
      listPrice,
      listPricePerSqft,
      dto.potential_equity ?? null,
      dto.cumulative_days_on_market ?? null,
      dto.image_url || null,
      dto.status ?? null,
      dto.days_since_sold ?? null
    );
  } catch (error) {
    console.error('Error mapping property DTO to domain', error);
    return null;
  }
}
